import { getFieldValue } from "@./state";

export function getPrice(flowId: string) {
  return Number(
    getFieldValue(flowId, "costTodayRaw")?.data.submitValue,
  );
}